import { UnitConversion, UnitConversionFilters } from '../../../../app/models/UnitConversion';
import ButtonTableAction from '../../../../components/buttons/ButtonTableAction';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';
import { formatAmount } from '../../../../utils/utils';
import UnitConversionFilter from './UnitConversionFilter';


interface Props {
    unitConversions: UnitConversion[];
    totalRows: number;
    loading?: boolean;
    edit?: (id: number) => void;
    show?: (id: number) => void;
    destroy?: (id: number) => void;
    filter: UnitConversionFilters;
    setFilter: (filter: UnitConversionFilters) => void;
    paginationRowsPerPageOptions?: any[];
    callbackSuccess: () => void;
}

const UnitConversionDataTable = ({
    unitConversions,
    totalRows,
    loading = false,
    edit,
    destroy,
    show,
    filter,
    setFilter,
    callbackSuccess
}: Props) => {
    const columns = [
        {
            name: 'Id',
            selector: (row: any) => row.id,
            sortable: true,
            sortField: 'id',
            cell: (row: UnitConversion, index: any, column: any) => <span className="">{row.id}</span>
        },
        {
            name: 'Producto',
            selector: (row: any) => row.product?.name ?? '',
            sortable: true,
            sortField: 'product',
            cell: (row: UnitConversion) => (
                <span>{row.product_cod ? `${row.product_cod} - ${row.product?.name ?? ''}` : (row.product?.name ?? '')}</span>
            )
        },
        {
            name: 'Unidad de Tarifa',
            selector: (row: any) => row.rate_unit,
            sortable: true,
            sortField: 'rate_unit',
            cell: (row: UnitConversion, index: any, column: any) => <span className="">{row.rate_unit?.name}</span>
        },
        {
            name: 'Unidad de Cantidad',
            selector: (row: any) => row.quantity_unit,
            sortable: true,
            sortField: 'quantity_unit',
            cell: (row: UnitConversion, index: any, column: any) => <span className="">{row.quantity_unit?.name}</span>
        },
        {
            name: 'Divisor',
            selector: (row: any) => row.divisor,
            sortable: true,
            sortField: 'divisor',
            cell: (row: UnitConversion, index: any, column: any) => <span className="">{formatAmount(row.divisor ?? 1)}</span>
        },
        {
            name: 'Acciones',
            selector: (row: any) => row.id,
            sortable: false,
            cell: (row: UnitConversion, index: any, column: any) => (
                <div className="">
                    {show && (
                        <ButtonTableAction
                            callbackFunction={() => show(row.id ?? -1)}
                            classIcon={'mdi mdi-eye'}
                            colorIcon={'text-info'}
                            errorMessage={'No se puede mostrar este registro.'}
                            title={'Ver'}
                        />
                    )}
                    {edit && (
                        <ButtonTableAction
                            callbackFunction={() => edit(row.id ?? -1)}
                            classIcon={'mdi mdi-pencil'}
                            colorIcon={'text-warning'}
                            errorMessage={'No se puede editar este registro.'}
                            title={'Editar'}
                        />
                    )}
                    {destroy && (
                        <ButtonTableAction
                            callbackFunction={() => destroy(row.id ?? -1)}
                            classIcon={'mdi mdi-delete'}
                            colorIcon={'text-danger'}
                            errorMessage={'No se puede eliminar este registro.'}
                            title={'Eliminar'}
                        />
                    )}
                </div>
            )
        }
    ];

    return (
        <>
            <div className="row mt-3">
                <div className="col">
                    <UnitConversionFilter filter={filter} setFilter={setFilter} />
                </div>
            </div>

            <DefaultDataTable
                columns={columns}
                data={unitConversions}
                progressPending={loading}
                paginationTotalRows={totalRows}
                filter={filter}
                setFilter={setFilter}
            />
        </>
    );
};

export default UnitConversionDataTable;
